var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1579 2.61343H0V0H15.1579V2.61343ZM15.1579 15.1584H0V12.5449H15.1579V15.1584ZM0 8.88589H15.1579V6.27246H0V8.88589ZM19.5351 9.40403L18 7.99949L19.5351 6.59495L23.3547 3.10079C23.5014 2.96649 23.7384 2.96649 23.8852 3.10079L24.8898 4.01993C25.0367 4.15377 25.0367 4.37057 24.8898 4.50487L21.0703 8.0001L24.8898 11.4947C25.0367 11.6284 25.0367 11.8458 24.8898 11.9795L23.8852 12.8986C23.7384 13.0325 23.5008 13.0325 23.3547 12.8986L19.5351 9.40403Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerBackIcon);
export default __webpack_public_path__ + "static/media/hamburger-back-icon.d36a46dc1e0f355a2848e70ad71e76f1.svg";
export { ForwardRef as ReactComponent };